import PropTypes from 'prop-types';

const NoMatches = ({ noMatchesFound, placeholder }) => {
  if (noMatchesFound) {
    return (
      <div className="px-2.5 py-1 leading-7 text-sm">
        <span>{placeholder}</span>
      </div>
    );
  }

  return null;
};

NoMatches.propTypes = {
  noMatchesFound: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default NoMatches;
